import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommunicationReport } from '../../../../documents';

@Component({
    selector: 'sponsor-communications-info',
    template: require('./sponsor-communications-info.component.html'),
    styles: [require('./document-info.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorCommunicationsInfoComponent  {

    @Input()
    public report: CommunicationReport;
}